module.exports = __webpack_public_path__ + "static/img/3 人文艺术讲座-黄怒波.e196cfe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/3 人文艺术讲座-黄怒波.jpeg
// module id = NVFV
// module chunks = 1